import React from 'react';
import LegacyForm from './LegacyForm';
import Version2025 from './Version2025';
import { getYear } from './data';

function SouthCarolinaForm(props) {
  const { version } = props;
  const isVersion2025OrLater = getYear(version) >= 2025;

  if (isVersion2025OrLater) return <Version2025 {...props} />;

  return <LegacyForm {...props} />;
}

export default SouthCarolinaForm;
